import { create } from "@/modules/core/store"
import type { TemplateEntity } from "@/modules/template/entities/templateEntity"

type TemplateImportActions = {
  setSearchTerm: (searchTerms: string | undefined) => void
  setSelectedTemplate: (selectedTemplate: TemplateEntity) => void
  clearSelectedTemplate: () => void
}
type TemplateImportState = {
  searchTerm: string | undefined
  selectedTemplate: TemplateEntity | null
  actions: TemplateImportActions
}

const useTemplateImportStore = create<TemplateImportState>()((set) => ({
  searchTerm: undefined,
  selectedTemplate: null,
  actions: {
    setSearchTerm: (searchTerm: string | undefined) => {
      set({ searchTerm })
    },
    setSelectedTemplate: (selectedTemplate: TemplateEntity) => {
      set({ selectedTemplate })
    },
    clearSelectedTemplate: () => {
      set({ selectedTemplate: null })
    },
  },
}))

export const useTemplateImportSearchTerm = () => useTemplateImportStore((state) => state.searchTerm)
export const useTemplateImportSelectedTemplate = () => useTemplateImportStore((state) => state.selectedTemplate)
export const useTemplateImportActions = () => useTemplateImportStore((state) => state.actions)
